<template>
  <p class="invite-url-box text-center">
    <span>{{ invitation_url }}</span>
    <span class="copy" @click="copyComplete" v-clipboard:copy="invitation_url" :title="$t('clickCopy')">{{ $t('copy') }}</span>
    <transition name="copy">
      <span class="copy-complete" v-show="copied">{{ $t('copySuccess') }}</span>
    </transition>
  </p>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'invite-url-component',
    data: function () {
      return {
        copied: false
      }
    },
    locales,
    props: {
      invitationCode: {}
    },
    computed: {
      invitation_url() {
        let inviteHost = window.location.href.match(/(\S*)\//)[1]
        return inviteHost + '?invite_code=' + this.invitationCode
      }
    },
    methods: {
      copyComplete: function () {
        this.copied = !this.copied
        setTimeout(() => {
          this.copied = false
        }, 2)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .copy-enter-active, .copy-leave-active {
    animation: copy .8s;
  }

  @keyframes copy {
    0% {
      opacity: 0
    }
    100% {
      opacity: 1
    }
  }

  .invite-url-box {
    margin: 0 auto;
    width: 100%;
    max-width: 4.6rem;
    position: relative;
    span:nth-child(1) {
      line-height: .28rem;
      padding: 0 .15rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow-x: hidden;
      display: inline-block;
      width: calc(100% - .54rem - .1rem);
      background: rgba(255,255,255,0.10);
      border: 1px solid rgba(224,215,227,1);
      border-radius: 14px;
      color:#666;
      font-size:12px;
    }
    .copy {
      float: right;
      width: .54rem;
      line-height: .28rem;
      background: #F15A66;
      border-radius: 14px;
      color: white;
      cursor: pointer;
      font-size:12px;
    }
    .copy-complete {
      clear: both;
      text-align: center;
      opacity: 0;
      font-size: 16px;
      border-radius: .05rem;
      color: #333;
      line-height: 0.24rem;
      background-color: #fff;
      box-shadow: 0px 2px 12px 0px rgba(153,153,153,0.24);
      position: absolute;
      top: -0.6rem;
      right: -5%;
      padding: 0.1rem 0.16rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?0a3a98c7